const React = require('react');
const Dialog = require('@material-ui/core/Dialog').default;
const DialogActions = require('@material-ui/core/DialogActions').default;
const DialogContent = require('@material-ui/core/DialogContent').default;
const DialogContentText = require('@material-ui/core/DialogContentText').default;
const ButtonB = require('../../../../dumb/Button/B');


module.exports = (props) => {
  return (
    <>
      <Dialog
        open={props.openConfirm}
        className="bgF>.MuiPaper-root"
      >
        <DialogContent>
          <DialogContentText>
            <span className="c0 fw5 f16 lh150%">
              You have already uploaded this document.
              Would you like to replace it with another?
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonB
            onClick={props.onConfirmClose}
          >Close</ButtonB>
          <ButtonB
            onClick={props.onConfirmOK}
          >Ok</ButtonB>
        </DialogActions>
      </Dialog>
      <Dialog
        open={props.openConfirmRemove}
        className="bgF>.MuiPaper-root"
      >
        <DialogContent>
          <DialogContentText>
            <span className="c0 fw5 f16 lh150%">
              You have already uploaded this document.
              Do you want to remove it?
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonB
            onClick={props.onConfirmRemoveClose}
          >Close</ButtonB>
          <ButtonB
            onClick={props.onConfirmRemoveOK}
          >Ok</ButtonB>
        </DialogActions>
      </Dialog>
    </>
  );
};
